import React, { useState } from 'react';
import { Box, IconButton } from '@mui/material';
import { CustomStyleCustomCarrousel } from './Styles';
import NotInformation from './NotInformation';
import { ArrowLeftIcon, ArrowRightIcon } from './buttons/IconButtons';
/**
 * @Author: Susana Garcia Rodriguez
 * @JobTitle: Frontend - IBL
 * @Email: sgarcia@ibl.mx
 *
 * @Description CustomCarrousel
 * A reusable carousel component that displays a list of images.
 *
 * @param {Array<string>} images: Array of image URLs to display in the carousel (optional, default is [])
 * @param {string} noInformationText: Text to display when no images are available (required)
 *
 * @returns {JSX.Element} A carousel component with navigation arrows, indicators, or a "no information" message
 */
const CustomCarrousel = ({ images = [],  noInformationText }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const hasImages = Array.isArray(images) && images.length > 0;
  const multipleImages = hasImages && images.length > 1;

  const handlePrev = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? images.length - 1 : prevIndex - 1
    );
  };

  const handleNext = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === images.length - 1 ? 0 : prevIndex + 1
    );
  };

  if (!hasImages) {
    return <NotInformation text={noInformationText} card={true} className={'h-250px'} />;
  }


  return (
    <Box sx={CustomStyleCustomCarrousel.container}>
      <Box
        component="img"
        src={images[currentIndex]}
        alt={`slide-${currentIndex}`}
        sx={CustomStyleCustomCarrousel.image}
      />

      {multipleImages && (
        <>
          <IconButton onClick={handlePrev} sx={CustomStyleCustomCarrousel.arrowLeft}>
            <ArrowLeftIcon className={'w-40px icon-color-shades-100'}/>
          </IconButton>
          <IconButton onClick={handleNext} sx={CustomStyleCustomCarrousel.arrowRight}>
            <ArrowRightIcon className={'w-40px icon-color-shades-100'} />
          </IconButton>
        </>
      )}

      {multipleImages && (
        <Box sx={CustomStyleCustomCarrousel.indicatorContainer}>
          {images.map((_, index) => (
            <Box
              key={index}
              sx={{
                ...CustomStyleCustomCarrousel.dot,
                ...(index === currentIndex && CustomStyleCustomCarrousel.dotActive),
              }}
              onClick={() => setCurrentIndex(index)}
            />
          ))}
        </Box>
      )}
    </Box>
  );
};

export default CustomCarrousel;
